/*
 * Small helpers for the SVG art.
 *
 * growStyle(len, durMs, delayMs = 0, easing = 'linear')
 *   The dash reveal: a style that grows a stroked path from its start. `len`
 *   is any value >= the path's real length. At the start the dash ends 4px
 *   before the path begins, so not even a round cap shows; at the end it
 *   covers the whole path. The un-animated style IS the finished path, so
 *   removing the animation (reduced motion, data-og-still) shows it complete.
 * anim(name, durMs, easing, delayMs = 0, rest = 'both')  an animation string
 * fmt(n, dp = 1)   a short number for path data
 * useSvgId()       a document-unique id prefix safe inside url(#...)
 */
import { useId } from 'react';

export function growStyle(len, durMs, delayMs = 0, easing = 'linear') {
  return {
    strokeDasharray: `${len}px ${len + 8}px`,
    '--og-from': `${len + 4}px`,
    animation: `og-grow ${durMs}ms ${easing} ${delayMs}ms both`,
  };
}

export function anim(name, durMs, easing, delayMs = 0, rest = 'both') {
  return `${name} ${durMs}ms ${easing} ${delayMs}ms ${rest}`;
}

export function fmt(n, dp = 1) {
  const v = Number(Number(n).toFixed(dp));
  return String(Object.is(v, -0) ? 0 : v);
}

export function useSvgId() {
  return `og${useId().replace(/[^a-zA-Z0-9_-]/g, '')}`;
}
